'use strict'

module.exports = function asString (value) {
  return value
}
